if (!customElements.get('gorgias-chat-button')) {
  class GorgiasChatButton extends HTMLElement {
    constructor() {
      super();
      this.boundOnClick = this.onClick.bind(this);
      this.boundOnOpen = this.onWidgetOpen.bind(this);
      this.boundOnClose = this.onWidgetClose.bind(this);
      this.observer = null;
      this.observerTimeout = null;
    }

    connectedCallback() {
      this.addEventListener('click', this.boundOnClick);
      this.initOnInteraction();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundOnClick);
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.observerTimeout) {
        clearTimeout(this.observerTimeout);
        this.observerTimeout = null;
      }
      if (window.GorgiasChat?.off) {
        window.GorgiasChat.off('widget:opened', this.boundOnOpen);
        window.GorgiasChat.off('widget:closed', this.boundOnClose);
      }
    }

    initOnInteraction() {
      const events = ['scroll', 'mousemove', 'touchstart', 'keydown'];
      const onInteraction = () => {
        events.forEach(e => window.removeEventListener(e, onInteraction));
        this.init();
      };
      events.forEach(e => window.addEventListener(e, onInteraction, { once: true, passive: true }));
    }

    init() {
      const initPromise = window.GorgiasChat
        ? window.GorgiasChat.init()
        : new Promise(resolve => {
            window.addEventListener('gorgias-widget-loaded', resolve, { once: true });
          });

      initPromise.then(() => {
        const container = document.querySelector('#gorgias-chat-container');
        if (container) {
          this.setup();
          return;
        }

        this.observer = new MutationObserver(() => {
          if (document.querySelector('#gorgias-chat-container')) {
            this.observer.disconnect();
            this.observer = null;
            clearTimeout(this.observerTimeout);
            this.observerTimeout = null;
            this.setup();
          }
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.observerTimeout = setTimeout(() => {
          if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
          }
          this.observerTimeout = null;
        }, 30000);
      });
    }

    setup() {
      if (!window.GorgiasChat || typeof window.GorgiasChat.isOpen !== 'function') return;
      this.removeAttribute('hidden');
      window.GorgiasChat.on('widget:opened', this.boundOnOpen);
      window.GorgiasChat.on('widget:closed', this.boundOnClose);
    }

    onClick() {
      if (!window.GorgiasChat) return;
      if (window.GorgiasChat.isOpen()) {
        window.GorgiasChat.close();
      } else {
        window.GorgiasChat.open();
      }
    }

    onWidgetOpen() {
      this.classList.add('active');
      this.setAttribute('aria-label', window.accessibilityStrings?.closeSupportChat || '');
    }

    onWidgetClose() {
      this.classList.remove('active');
      this.setAttribute('aria-label', window.accessibilityStrings?.openSupportChat || '');
    }
  }

  customElements.define('gorgias-chat-button', GorgiasChatButton);
}
